import type { CreateSharedMedia, MediaShare } from '@cobliteam/common-types';
import camelcaseKeys from 'camelcase-keys';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { toCreateSharedMediaRequestAPI } from './mediaTransformer';

export class SharedMediaRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public shareMedia = (createSharedMediaAPI: CreateSharedMedia): Promise<MediaShare> => {
    const requestData: IRequest = {
      endpoint: '/cameras/media/shared',
      method: HttpMethod.POST,
      body: JSON.stringify(toCreateSharedMediaRequestAPI(createSharedMediaAPI)),
    };
    return this.requester
      .request(requestData)
      .then((response) => camelcaseKeys(response.data))
      .catch((err) => {
        throw err;
      });
  };
}

export default SharedMediaRequester;
